import NextHead from 'next/head';
import { PageConfig, SeoComponent } from '@model/content';
import { TripTypes } from '@model/common';
import { Name } from '@model/iceberg';
import { getDestinationMetaDescription, getDestinationMetaTitle } from '@model/meta/destination-meta';
import { useI18NextContext } from '@components/hooks';
import { ComponentHandles } from '@util/content';

interface DestinationMetaProps extends Pick<PageConfig, 'components'> {
  destination: Name;
  tripType: TripTypes;
}

export const DestinationMeta = ({ components, destination, tripType }: DestinationMetaProps) => {
  const pageSeo = components.find(({ handle }) => handle === ComponentHandles.PAGE_SEO);
  if (pageSeo && (pageSeo as SeoComponent).title) {
    return null;
  }
  const t: any = useI18NextContext();
  const metaTitle = getDestinationMetaTitle(destination, tripType, t);
  const metaDescription = getDestinationMetaDescription(destination, tripType, t);

  return (
    <NextHead>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
    </NextHead>
  );
};
